<div [ngClass]="{'loader-blur': isLoading}">
    <router-outlet></router-outlet>
</div>
   
<div class="loader-container" *ngIf="percentageCount">
  <div  class="q-percentage-loader">
    <p style="font-weight: bold;">{{percentageCount}}</p>
    <p *ngIf="displayText">
      Please wait! We are processing your quotation.
    </p>
  </div>

  <div class="dot-spinner" *ngIf="isLoading">
    <div class="dot-spinner__dot"></div>
    <div class="dot-spinner__dot"></div>
    <div class="dot-spinner__dot"></div>
    <div class="dot-spinner__dot"></div>
    <div class="dot-spinner__dot"></div>
    <div class="dot-spinner__dot"></div>
    <div class="dot-spinner__dot"></div>
    <div class="dot-spinner__dot"></div>
  </div>

  <div *ngIf="percentageCount" class="q-percentage-info">
    <p style="font-weight: bold;">Thank you for your patience!</p>
    <p class="mt-2">
      Your quotation is on the way! Please wait a moment while it loads.
    </p>
    <p class="mt-1" style="color: #6699ff;">
      If it's delayed, we'll email it to you shortly.
    </p>
  </div>
</div>
<div class="dot-spinner" *ngIf="isLoading && percentageCount == ''">
  <div class="dot-spinner__dot"></div>
  <div class="dot-spinner__dot"></div>
  <div class="dot-spinner__dot"></div>
  <div class="dot-spinner__dot"></div>
  <div class="dot-spinner__dot"></div>
  <div class="dot-spinner__dot"></div>
  <div class="dot-spinner__dot"></div>
  <div class="dot-spinner__dot"></div>
</div>
